// add leading zero's to single digit, positive numbers
const padNumber = (n: number | string): string => (n > 0 && n < 10) ? `0${n}` : `${n}`;
export default padNumber;
